
import React from 'react';
import {
    main,
    marTar01,
    marTar02,
    marTar03,
    marTar04,
    marTar05,
    marTar06,
    marTar07,
    marTar08,
    marTar09,
    marTar10,
    marTar11,
    marTar12,
    marTar13,
    marTar14,
    marTar15,
    marTar16,
    marTar17,
    marTar18,
    marTar19,
    marTar20,
    marTar21,
    marTar22,
    marTar23,
    marTar24,
    marTar25,
    marTar26,
    marTar27,
    marTar28,
    marTar29,
    marTar30,
    marTar31,
    marTar31a,
    marTar32,
    marTar33,
    marTar34,
    marTar35,
    marTar36,
    marTar37,
    marTar38,
    marTar39,
    marTar40,
    marTar41,
    marTar42,
    marTar43,
    marTar44,
    marTar45,
} from '../OurCouplesPics/MartaTaras';


export const MartaAndTaras = {
    bgColor: "bgDark",
    title: "Marta i Taras – romantyczne wesele w sercu Wrocławia",
    path: "romantyczne-wesele-w-sercu-wroclawia",
    minHeight: true,
    seoTitle: "Marta i Taras – romantyczne wesele w sercu Wrocławia",
    seoText: "Eleganckie, romantyczne i pełne światła – wesele Marty i Tarasa w The Bridge to opowieść o miłości w rytmie miasta.",
    mainPic: {
        src: main
    },
    details: "Eleganckie, romantyczne i pełne światła – wesele Marty i Tarasa w The Bridge to opowieść o miłości w rytmie miasta. Humanistyczna ceremonia w ogrodzie, wyjątkowe dekoracje i zabawa pod gwiazdami stworzyły klimat pełen emocji i pięknych detali.",
    org: "Agencja Ślubna Czary Marry",
    orgLink: "",
    place: "Hotel The Bridge Wrocław",
    placeLink: "",
    decor: "Anello Decor",
    decorLink: "https://www.anellodecor.pl/",
    photo: "Paulina Pietraszkiewicz",
    photoLink: "",
    music: "Adam Łucki",
    musicLink: "",
    movie: "Hey Folks",
    movieLink: "",
    date: "27 gru 2025",
    textMain:
        "W samym centrum Wrocławia, w otoczeniu zabytkowych murów Ostrowa Tumskiego, Marta i Taras zorganizowali ślub i wesele, które łączyły elegancję miasta z romantyzmem pleneru. Ten dzień był pełen emocji, światła i wzajemnej bliskości – dokładnie taki, jak oni.",
    topPic: { src: main },
    content: [
        {
            headerSmall: 'Zaufanie, spokój i wspólna wizja',
            headerClassName: "dark",
            text: <>
                <p>Z Martą i Tarasem od pierwszego spotkania wiedziałyśmy, że współpraca będzie wyjątkowa. Ciepło, spokój i naturalność tej dwójki od razu wprowadziły atmosferę zaufania. Oddali nam organizację swojego ślubu i wesela, chcąc przeżyć ten dzień bez pośpiechu, w otoczeniu najbliższych i pięknych emocji.</p>
                <p> Ich wizja była jasna – eleganckie, miejskie wesele z nutą romantyzmu, w którym każdy detal ma znaczenie, ale nic nie jest przesadzone. Dzięki temu mogłyśmy stworzyć wydarzenie, które idealnie odzwierciedlało ich styl i osobowość.</p></>,
            pics: [
                { src: marTar01 },
                { src: marTar02 },
                { src: marTar03 },
                { src: marTar04 },
            ]
        },
        {
            headerSmall: "Przygotowania w hotelowych wnętrzach",
            headerClassName: "dark",
            text: <>
                <p>
                    Poranek Marty i Tarasa był spokojny i pełen ciepła. Marta przygotowywała się w hotelowym apartamencie ze swoją przyjaciółką, która była jednocześnie jej świadkową. W atmosferze lekkości i radości wspólnie celebrowały pierwsze chwile tego wyjątkowego dnia. Taras rozpoczął przygotowania sam, w ciszy i skupieniu, a później dołączył do niego świadek, wprowadzając dobrą energię i luz.
                </p>
                <p>
                    Para zdecydowała, że zobaczą się dopiero podczas ceremonii w ogrodzie. Moment ich pierwszego spotkania był pełen emocji, prosty i bardzo poruszający - dokładnie taki, jak wyobrażali sobie początek tego dnia.
                </p>
            </>,
            pics: [
                { src: marTar05 },
                { src: marTar06 },
                { src: marTar07 },
                { src: marTar08 },
                { src: marTar09 },
                { src: marTar10 },
                { src: marTar11 },
                { src: marTar12 },
                { src: marTar13 },
                { src: marTar14 },
            ]
        },
        {
            headerSmall: "Ślub w ogrodzie The Bridge – w blasku emocji i światła",
            headerClassName: "dark",
            text: <>
                <p>Ceremonia Marty i Tarasa odbyła się w ogrodzie hotelu The Bridge – miejscu, które łączy miejski klimat z naturalnym spokojem. W słoneczne popołudnie, w otoczeniu zieleni i kwiatów, para stanęła naprzeciw siebie po raz pierwszy tego dnia. Martę do ceremonii poprowadził tata. Ten moment, pełen emocji i wzruszenia, na długo pozostał w pamięci wszystkich gości.</p>
                <p>Ślub miał charakter humanistyczny i był prowadzony w dwóch językach – polskim i ukraińskim. Marta i Taras bardzo starannie wybierali celebranta, chcąc, by był bliski ich energii i sposobowi bycia. Przysięgi, które sami napisali, były pełne szczerości, czułości i humoru. Wspomnienie o „Małym Księciu” i słowach o oswajaniu wywołało uśmiech i łzy wzruszenia na twarzach gości.</p>
            </>,
            pics: [
                { src: marTar15 },
                { src: marTar16 },
                { src: marTar17 },
                { src: marTar18 },
                { src: marTar19 },
                { src: marTar20 },
                { src: marTar21 },
                { src: marTar22 },
                { src: marTar23 },
                { src: marTar24 },
            ]
        },
        {
            headerSmall: "Dekoracje – romantyczna elegancja w miejskim stylu",
            headerClassName: "dark",
            text: <>
                <p>Dekoracje przygotowane przez Anello Decor stanowiły połączenie ponadczasowej elegancji z miejskim charakterem i romantycznością kwiatów. Centralnym punktem aranżacji były kryształowe żyrandole oplecione kwiatami, które zawisły nad stołami gości i Pary Młodej.</p>
                <p>Kwiaty w odcieniach brzoskwini, różu, kremu i bordo wprowadziły ciepło i miękkość, a ciemne tło sali podkreśliło ich formę i nadało całości głębi. Welurowe obrusy, ornamentowe podtalerze, kryształowe szkło i eleganckie świeczniki stworzyły aranżację, w której każdy element był idealnie dopasowany. Wśród detali wyróżniały się betonowe winietki i numerki stołów, ręcznie wypisane kaligrafią – subtelny, ale wyrazisty akcent, który idealnie dopełnił całość.</p>
                <p>Nic w tych dekoracjach nie było przypadkowe – każdy detal miał do siebie pasować, tworząc harmonijną, dopracowaną kompozycję. Styl dekoracji był idealnym połączeniem nowoczesnego, miejskiego charakteru z romantyczną lekkością kwiatów.</p>
                <p>Wyjątkowym uzupełnieniem scenografii było światło architektoniczne przygotowane przez Pawła Małeckiego i jego zespół. Ciepłe, delikatne oświetlenie w ciągu dnia subtelnie podkreślało florystyczne detale, a wieczorem różowo-złote tony wydobyły blask żyrandoli i nadały wnętrzu romantyczny nastrój. Dzięki temu sala zmieniała się wraz z upływem dnia – od eleganckiej przestrzeni obiadu po nastrojową scenerię tanecznej nocy.</p>
            </>,
            pics: [
                { src: marTar25 },
                { src: marTar26 },
                { src: marTar27 },
                { src: marTar28 },
                { src: marTar29 },
                { src: marTar30 },
                { src: marTar31 },
                { src: marTar31a },
            ]
        },
        {
            headerSmall: "Ogród, światła i muzyka – tak zaczęła się noc",
            headerClassName: "dark",
            text: <>
                <p>
                    Po obiedzie i wzruszających przemówieniach, zamiast tradycyjnego pierwszego tańca, Marta i Taras zaprosili swoich gości do ogrodu. Tam czekała strefa chilloutu z muzyką, rozmowami i pysznymi drinkami.</p>
                <p>
                    DJ Adam Łucki rozłożył swoją konsolę w ogrodzie i rozpoczął taneczny set pod gołym niebem. Goście bawili się, tańczyli i odpoczywali w otoczeniu zieleni i światła miasta.</p>
                <p>
                    O 22:00 zaserwowano tort – w blasku lampek i oklasków. Ten moment był symbolicznym przejściem do drugiej części wieczoru. Wtedy zaprosiliśmy wszystkich do środka, gdzie Marta i Taras, w wyjątkowej atmosferze, otworzyli parkiet swoim pierwszym tańcem.
                    To lekkie odwrócenie harmonogramu dnia okazało się doskonałym pomysłem – dodało rytmu, luzu i naturalnej dynamiki całemu wydarzeniu.
                </p>
            </>,
            pics: [
                { src: marTar32 },
                { src: marTar33 },
                { src: marTar34 },
                { src: marTar35 },
                { src: marTar36 },
                { src: marTar37 },
                { src: marTar38 },
                { src: marTar39 },
                { src: marTar40 },
                { src: marTar41 },
            ]
        },
        {
            headerSmall: "Miłość w każdym detalu",
            headerClassName: "dark",
            text: "To jedno z tych wesel, które od początku do końca opierało się na zaufaniu, spokoju i radości. Marta i Taras pozwolili nam stworzyć dzień, który w każdym detalu był o nich – elegancki, pełen ciepła i prawdziwych emocji. Wspólnie dopracowałyśmy każdy element – od koncepcji, przez wybór miejsca i dostawców, aż po koordynację dnia ślubu.Efekt był dokładnie taki, jak oni: subtelny, harmonijny i pełen miłości.",
            pics: [
                { src: marTar42 },
                { src: marTar43 },
                { src: marTar44 },
                { src: marTar45 },
            ]
        },
    ],
}